import { render, staticRenderFns } from "./Zfyz.vue?vue&type=template&id=bbce1220&scoped=true"
import script from "./Zfyz.vue?vue&type=script&lang=js"
export * from "./Zfyz.vue?vue&type=script&lang=js"
import style0 from "./Zfyz.vue?vue&type=style&index=0&id=bbce1220&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbce1220",
  null
  
)

export default component.exports